<template>
    <div class="box_content">  
        <div class="top_nav">
            <div class="nav_title" v-for="(item,index) in navTitle" :key="index" :class="index==nav_id?'active_title':''" @click="clickTitle(index)">
                {{item}}
            </div>
        </div>
        <template v-if="load">
            <template  v-if="list.length">
                <div class="main_tem">
                    <div class="tem_user" v-for="(item,indes) in list" :key="indes">
                        <div class="left_tem">
                            <div class="user_img">    
                                <img :src="$OSSBaseUrl+'yesterday/ww.png'" alt="">
                            </div>
                            <div class="right_user">
                                <div class="user_info">
                                    <div class="nick_name">{{item.member_nick}}</div>
                                    <div class="nick_desc">
                                        <div class="cg_order">采购订单：{{item.tid_num}}笔</div>
                                        <div class="fk_order">付款金额：{{item.sum_payment}}元</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button class="copy_btn"
                            v-clipboard:copy="item.member_nick"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError">立即回复</button>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="notHasData">
                    暂无数据
                </div>
            </template>
            <div class="con_config">
                <Popup
                v-model="popup_show"
                position="top"
                overlay-class="popup_box"
                :close-on-click-overlay="true"
                :lock-scroll="true"
                :lazy-render="false"
                >
                    <img class="WXTExtension_popup" :src="popup_img" />
                </Popup>
            </div>
            <div class="special_popup_box">
                <!-- 服务到期 续费提醒 弹窗 -->
                <Popup v-model="IsTimeOut" position="center">
                    <div class="popup_IsTimeOut">
                        <img @click="popup_IsTimeOut_close" class="popup_IsTimeOut_close" :src="$OSSBaseUrl+'close.png'" alt="关闭">
                        <img class="popup_IsTimeOut_img" :src="$OSSBaseUrl+'YesterdayBriefingTimeOut.png'" alt="到期图标">
                        <div class="popup_IsTimeOut_title">旺信通服务已过期</div>
                        <div class="popup_IsTimeOut_text">无法查看数据，以免数据丢失</div>
                        <div class="popup_IsTimeOut_text">请尽快续费！</div>
                        <div @click="popup_IsTimeOut_button" class="popup_IsTimeOut_button">立即续费</div>
                    </div>
                </Popup>
                <!-- 服务到期 续费提醒 弹窗 -->
                <Popup v-model="InterruptData" position="center">
                    <div class="popup_InterruptData">
                        <img @click="popup_InterruptData_close" class="popup_InterruptData_close" :src="$OSSBaseUrl+'close.png'" alt="关闭">
                        <img class="popup_InterruptData_img" :src="$OSSBaseUrl+'YesterdayBriefingSyncData.png'" alt="到期图标">
                        <div class="popup_InterruptData_title">数据同步中</div>
                        <div class="popup_InterruptData_text">由于服务到期导致数据中断</div>
                        <div class="popup_InterruptData_text">系统正在同步数据，请稍后查看</div>
                    </div>
                </Popup>
            </div>
        </template>
    </div>
</template>
<script>
import { Toast, Tab, Tabs, Popup } from 'vant';
export default {
    name: 'YesterdayDetail',
    data(){
        let popup_img;
        if (this.$config.SystemOS == "IOS") {
            popup_img = this.$OSSBaseUrl + "renew_tips_ios.png";
        } else {
            popup_img = this.$OSSBaseUrl + "renew_tips_android.png";
        }
        return{
            load: false,
            InterruptData: false,
            IsTimeOut: false,
            popup_show: false,
            popup_img,
            list: [],
            nav_id:'1',
            navTitle:{'1':'新客户','2':'老客户','3':'忠诚客户'}
        }
    },
    components:{
        Toast,
        Tab,
        Tabs,
        Popup
    },
    mounted(){
        this.getData({visitor_id:this.$route.query.visitor_id, customer_type:'1',})
    },
    methods:{
        // 关闭过期提示弹窗
        popup_IsTimeOut_close(){
            this.IsTimeOut = false
        },
        popup_IsTimeOut_button(){
            this.popup_show = true
        },
        // 关闭过期提示弹窗
        popup_InterruptData_close(){
            this.InterruptData = false
        },
        // 导航栏
        clickTitle(id){
            this.nav_id=id
            this.getData({visitor_id:this.$route.query.visitor_id, customer_type:this.nav_id,})
        },
        // 复制按钮
        onCopy(){
            console.log("复制成功")
            Toast('复制成功')
        },
        onError(){
            console.log('复制失败')
            Toast('复制失败')
        },
        // 获取数据
        getData(params){
            this.$store.dispatch('YesterdayBriefing/YesterdayCustomer',params).then(res=>{
                this.load = true
                if(!params.visitor_id){
                    if (res.code == "4031") {
                        this.IsTimeOut = true;
                    }
                    if (res.code == "4032") {
                        this.InterruptData = true;
                    }
                    if(res.code == "4019"){
                        Toast("消息不存在")
                    }
                    if(res.code == "4029"){
                        Toast("非店铺老板无权查看")
                    }
                    if(res.code == "4030"){
                        Toast("新绑定用户还未更新昨日数据，明日可点击查看")
                    }
                }
                if(res.code == '1000'){
                    this.InterruptData = false;
                    this.IsTimeOut = false;
                }
                this.list = res.data
            })
        },
    },
}
</script>
<style lang="scss" scoped>
    @import './index.scss';
</style>